import {
  CONFIGURE_OEM_TICKET_TYPE_MUTATION,
  CREATE_OEM_TICKET_TYPE_MUTATION,
  CURRENT_USER_QUERY,
  DELETE_OEM_TICKET_TYPE_MUTATION,
  UPDATE_OEM_TICKET_TYPE_MUTATION,
} from "#/src/api";
import { errorsHandler } from "#/src/transformers";
import { useMutation } from "@apollo/client";

export const useCreateOemTicketType = () => {
  const [create, { loading, error }] = useMutation(
    CREATE_OEM_TICKET_TYPE_MUTATION,
  );

  return {
    loading,
    error,
    createTicketType: async (input) =>
      new Promise((resolve, reject) => {
        return create({
          variables: { input },
          update(cache, { data: { createOemTicketType: ref } = {} }) {
            const { currentUser } =
              cache.readQuery({
                query: CURRENT_USER_QUERY,
              }) || {};

            if (currentUser) {
              cache.writeQuery({
                query: CURRENT_USER_QUERY,
                data: {
                  currentUser: {
                    ...currentUser,
                    oem: {
                      ...currentUser.oem,
                      ticketTypes: [...currentUser.oem.ticketTypes, ref],
                    },
                  },
                },
              });
            }
          },
        })
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(errorsHandler(err));
          });
      }),
  };
};

export const useUpdateOemTicketType = () => {
  const [updateType, { loading, error }] = useMutation(
    UPDATE_OEM_TICKET_TYPE_MUTATION,
  );

  return {
    loading,
    error,
    updateTicketType: async (id, input) =>
      new Promise((resolve, reject) => {
        return updateType({
          variables: { id, input },
          update(cache, { data: { updateOemTicketType: ref } = {} }) {
            const { currentUser } =
              cache.readQuery({
                query: CURRENT_USER_QUERY,
              }) || {};

            if (currentUser) {
              const ticketTypes = [...currentUser.oem.ticketTypes];
              const index = ticketTypes.findIndex((type) => type._id === id);

              if (index >= 0) {
                ticketTypes.splice(index, 1, ref);
              }

              cache.writeQuery({
                query: CURRENT_USER_QUERY,
                data: {
                  currentUser: {
                    ...currentUser,
                    oem: {
                      ...currentUser.oem,
                      ticketTypes,
                    },
                  },
                },
              });
            }
          },
        })
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(errorsHandler(err));
          });
      }),
  };
};

export const useDeleteOemTicketType = () => {
  const [remove, { loading, error }] = useMutation(
    DELETE_OEM_TICKET_TYPE_MUTATION,
  );

  return {
    loading,
    error,
    deleteWorkOrderType: async (id, input) => {
      return new Promise((resolve, reject) => {
        return remove({
          variables: { id, input },
          update(cache, { data: { deleteOemTicketType: ref } }) {
            const { currentUser } =
              cache.readQuery({
                query: CURRENT_USER_QUERY,
              }) || {};

            if (currentUser && ref === "ok") {
              const ticketTypes = [...currentUser.oem.ticketTypes];
              const index = ticketTypes.findIndex((type) => type._id === id);

              if (index >= 0) {
                ticketTypes.splice(index, 1);
              }

              cache.writeQuery({
                query: CURRENT_USER_QUERY,
                data: {
                  currentUser: {
                    ...currentUser,
                    oem: {
                      ...currentUser.oem,
                      ticketTypes,
                    },
                  },
                },
              });

              cache.evict({
                id: "ROOT_QUERY",
                fieldName: "listOwnOemAllTickets",
              });
              cache.gc();
            }
          },
        })
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(errorsHandler(err));
          });
      });
    },
  };
};

export const useConfigureWorkOrderForm = () => {
  const [updateForm, { loading, error }] = useMutation(
    CONFIGURE_OEM_TICKET_TYPE_MUTATION,
  );

  return {
    loading,
    error,
    configureForm: async (id, input) =>
      new Promise((resolve, reject) => {
        return updateForm({
          variables: { id, input },
          update(cache, { data: { configureOemTicketType: ref } = {} }) {
            const { currentUser } =
              cache.readQuery({
                query: CURRENT_USER_QUERY,
              }) || {};

            if (currentUser) {
              const ticketTypes = [...currentUser.oem.ticketTypes];
              const index = ticketTypes.findIndex((type) => type._id === id);

              if (index >= 0) {
                ticketTypes.splice(index, 1, ref);
              }

              cache.writeQuery({
                query: CURRENT_USER_QUERY,
                data: {
                  currentUser: {
                    ...currentUser,
                    oem: {
                      ...currentUser.oem,
                      ticketTypes,
                    },
                  },
                },
              });
            }
          },
        })
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(errorsHandler(err));
          });
      }),
  };
};
